import { AsyncAxiosRequestConfig } from 'core/common';
import { axiosInstance } from 'config';
import { GetEntitiesResponse, SellerInfoResponse } from './entity.model';

class EntitiesAPI {
  getEntities({
    params: { username, isEmployee },
  }: AsyncAxiosRequestConfig<{
    username: string;
    isEmployee: boolean;
  }>) {
    return axiosInstance
      .get<GetEntitiesResponse>(
        `/servicios_fijos/v1/users/${username}?is_employee=${isEmployee}`
      )
      .then(({ data }) => data?.entities ?? []);
  }

  checkDocumentNumber(
    options: AsyncAxiosRequestConfig<{
      entity_id: string;
      document_number: string;
    }>
  ) {
    return axiosInstance
      .get<SellerInfoResponse>('/servicios_fijos/v1/sellers', options)
      .then(({ data: { seller } }) => {
        return { ...seller, documentNumber: options.params.document_number };
      });
  }
}

export default new EntitiesAPI();
